import { render, staticRenderFns } from "./form.vue?vue&type=template&id=16413da6&"
import script from "./form.vue?vue&type=script&lang=js&"
export * from "./form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\DevOpsAgent\\agent1\\_work\\10\\s\\Site\\Source\\Web\\Marketing.UI\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('16413da6')) {
      api.createRecord('16413da6', component.options)
    } else {
      api.reload('16413da6', component.options)
    }
    module.hot.accept("./form.vue?vue&type=template&id=16413da6&", function () {
      api.rerender('16413da6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "Views/Marketing/ProForm/components/templates/form.vue"
export default component.exports